var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.label,"value":_vm.value.amount,"prefix":"$","rules":[function (v) { return v > 0 || 'Amount has to be greater than 0'; }]},on:{"input":_vm.setAmount}})}
var staticRenderFns = []

export { render, staticRenderFns }